import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'flow-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss']
})
export class StartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
